import { createAction } from 'typesafe-actions';
import { IConsentValues } from '../types/cookieBanner.type';
export const setConsentValues = createAction('setConsentValues', (action) => {
	return (consentValues: IConsentValues) => action({ consentValues });
});
